/* eslint-disable no-param-reassign */
import breadcrumbSchema from '../schemas/breadcrumb';
import itemlistSchema from '../schemas/itemlist';
import courseSkeletonSchema from '../schemas/freeLessonCourse';
import videoObjectSchema from '../schemas/videoObject';

const lessonSchema = ({
  freeLessonList,
  courseInfo,
  freeLessonInfo,
  description
}) => {
  const lessonInfo = { ...(freeLessonInfo || {}) };
  if (lessonInfo.collection) {
    lessonInfo.goal = lessonInfo.collection?.goal || courseInfo?.goal;
    lessonInfo.topic =
      lessonInfo.goalName ||
      lessonInfo.collection?.goalName ||
      lessonInfo.goal?.name ||
      lessonInfo.collection?.goal?.name;
    lessonInfo.viewCount =
      lessonInfo.collection?.viewCount || courseInfo?.viewCount;
  }
  if (lessonInfo.collection?.progress)
    lessonInfo.startsAt = lessonInfo.collection.progress.createdAt;
  lessonInfo.thumbnail =
    lessonInfo.thumbnail ||
    lessonInfo.video?.thumbnail ||
    lessonInfo.collection?.thumbnail;
  const breads = [
    {
      name: 'Explore',
      url: 'https://www.unacademy.com/explore'
    }
  ];

  if (lessonInfo.collection?.name) {
    breads.push({
      name: lessonInfo.collection.name,
      url: lessonInfo.collection.permalink
    });
  }

  if (lessonInfo.permalink) {
    breads.push({
      name: lessonInfo.name || lessonInfo.title,
      url: lessonInfo.permalink
    });
  }

  const itemListElement = freeLessonList?.map((lesson, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    url: lesson.permalink || lesson.value?.permalink
  }));

  const graph = [];
  const courseSchema = courseSkeletonSchema({
    ...lessonInfo,
    ...(lessonInfo.collection || {}),
    cover_photo: lessonInfo.collection?.coverPhoto,
    forPlus:
      lessonInfo.collection?.forPlus ||
      lessonInfo.collection?.forSubscription ||
      false,
    description
  });
  const breadCrumbSchema = breadcrumbSchema(breads);
  if (breadCrumbSchema) graph.push(breadCrumbSchema);
  if (courseSchema) graph.push(courseSchema);

  if (lessonInfo.startsAt) {
    graph.push(
      videoObjectSchema({
        ...lessonInfo,
        videoUrl: lessonInfo.video?.url || null,
        embedUrl: lessonInfo.video?.embedUrl || null,
        lessonDuration:
          lessonInfo.videoDuration ||
          lessonInfo.duration ||
          lessonInfo.video?.duration,
        description
      })
    );
  }
  if (lessonInfo.title && freeLessonList?.length) {
    graph.push(itemlistSchema(lessonInfo.title, itemListElement));
  }

  const schema = {
    '@context': 'https://schema.org/',
    '@graph': graph
  };

  return schema;
};

export default lessonSchema;
